import React from 'react';
import { Spinner } from 'react-bootstrap';
import type { SkinSeoulAdminProduct } from '../../../../../models/ProductTypes';
import { SkinSeoulProductType } from '../../../../../models/ProductTypes';
import { AdminProductCard } from '../../../components/admin-product-card/AdminProductCard';

interface AdminProductCardListProps {
  readonly products: SkinSeoulAdminProduct[];
  readonly loading: boolean;
}

export const AdminProductCardList: React.FC<AdminProductCardListProps> = ({ products, loading }) => {
  if (loading) {
    return <Spinner animation="border" size="sm" className="me-2" />;
  }

  if (products.length === 0) {
    return (
      <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
        No products found
      </p>
    );
  }

  return (
    <div className="mb-4 p-3 border rounded">
      <div className="d-flex flex-column gap-3">
        {products.map((product, index) => (
          <React.Fragment key={index}>
            <AdminProductCard
              product={product}
              index={index}
              isSelected={false}
              onSelect={() => {
                // No selection needed for review
              }}
              showImage={true}
              showQuickLinks={true}
            />

            {/* Variations */}
            {product.type === SkinSeoulProductType.Variable &&
              product.variations &&
              product.variations.length > 0 &&
              product.variations.map((variation, variationIndex) => (
                <AdminProductCard
                  key={`${index}-var-${variationIndex}`}
                  product={variation}
                  index={index}
                  isSelected={false}
                  onSelect={() => {
                    // No selection needed for review
                  }}
                  isVariation={true}
                  parentIndex={index}
                  variationIndex={variationIndex}
                  showImage={false}
                  showQuickLinks={false}
                />
              ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
